/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  ChangePasswordRequest,
  CreateEmployeeRequest,
  CreateUserRequest,
  ForgotPasswordRequest,
  GetUserBaseResponse,
  GetUserByEmailRequest,
  GetUserResponse,
  GoogleLoginRequest,
  LoginRequest,
  LoginResponse,
  PaginatedResultOfGetUserResponse,
  ProblemDetails,
  RefreshTokenRequest,
  ResetPasswordRequest,
  Result,
  ResultOfCreateUserResponse,
  ResultOfEmailNotificationResponse,
  ResultOfRefreshTokenResponse,
  ResultOfSetEmployeeRolesResponse,
  ScrollUserRequest,
  SetEmployeeRoleRequest,
  UpdateUserRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
    CreateEmployeeRequestFromJSON,
    CreateEmployeeRequestToJSON,
    CreateUserRequestFromJSON,
    CreateUserRequestToJSON,
    ForgotPasswordRequestFromJSON,
    ForgotPasswordRequestToJSON,
    GetUserBaseResponseFromJSON,
    GetUserBaseResponseToJSON,
    GetUserByEmailRequestFromJSON,
    GetUserByEmailRequestToJSON,
    GetUserResponseFromJSON,
    GetUserResponseToJSON,
    GoogleLoginRequestFromJSON,
    GoogleLoginRequestToJSON,
    LoginRequestFromJSON,
    LoginRequestToJSON,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    PaginatedResultOfGetUserResponseFromJSON,
    PaginatedResultOfGetUserResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RefreshTokenRequestFromJSON,
    RefreshTokenRequestToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateUserResponseFromJSON,
    ResultOfCreateUserResponseToJSON,
    ResultOfEmailNotificationResponseFromJSON,
    ResultOfEmailNotificationResponseToJSON,
    ResultOfRefreshTokenResponseFromJSON,
    ResultOfRefreshTokenResponseToJSON,
    ResultOfSetEmployeeRolesResponseFromJSON,
    ResultOfSetEmployeeRolesResponseToJSON,
    ScrollUserRequestFromJSON,
    ScrollUserRequestToJSON,
    SetEmployeeRoleRequestFromJSON,
    SetEmployeeRoleRequestToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
} from '../models/index';

export interface ApiUserAuthChangePasswordPostRequest {
    changePasswordRequest: ChangePasswordRequest;
    xTenantID?: number;
}

export interface ApiUserAuthForgotPasswordPostRequest {
    forgotPasswordRequest: ForgotPasswordRequest;
    xTenantID?: number;
}

export interface ApiUserAuthRefreshTokenPostRequest {
    refreshTokenRequest: RefreshTokenRequest;
    xTenantID?: number;
}

export interface ApiUserAuthResetPasswordPostRequest {
    resetPasswordRequest: ResetPasswordRequest;
    xTenantID?: number;
}

export interface ApiUserAuthRevokeTokenPostRequest {
    email?: string;
    xTenantID?: number;
}

export interface ApiUserCreateAdminPostRequest {
    createUserRequest: CreateUserRequest;
    xTenantID?: number;
}

export interface ApiUserCreateMemberPostRequest {
    createUserRequest: CreateUserRequest;
    xTenantID?: number;
}

export interface ApiUserCreateStaffPostRequest {
    createUserRequest: CreateUserRequest;
    xTenantID?: number;
}

export interface ApiUserEmployeePostRequest {
    createEmployeeRequest: CreateEmployeeRequest;
    xTenantID?: number;
}

export interface ApiUserIdDeactivatePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiUserIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiUserLoginPostRequest {
    loginRequest: LoginRequest;
    xTenantID?: number;
}

export interface ApiUserPutRequest {
    updateUserRequest: UpdateUserRequest;
    xTenantID?: number;
}

export interface ApiUserRegisterMemberPostRequest {
    createUserRequest: CreateUserRequest;
    xTenantID?: number;
}

export interface ApiUserTestAuthorizationGetRequest {
    xTenantID?: number;
}

export interface ApiUserUserIdEmployeeRolePutRequest {
    userId: number;
    setEmployeeRoleRequest: SetEmployeeRoleRequest;
    xTenantID?: number;
}

export interface ApiUsersFindByEmailPostRequest {
    getUserByEmailRequest: GetUserByEmailRequest;
    xTenantID?: number;
}

export interface ApiUsersIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface GoogleLoginOperationRequest {
    googleLoginRequest: GoogleLoginRequest;
    xTenantID?: number;
}

export interface GoogleLoginCallbackRequest {
    tid?: ApiUserTasksGetPageParameter;
    rid?: string;
    returnUrl?: string;
    xTenantID?: number;
}

export interface UsersByRoleGetRequest {
    role?: string;
    xTenantID?: number;
}

export interface UsersScrollPostRequest {
    scrollUserRequest: ScrollUserRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Change password
     */
    async apiUserAuthChangePasswordPostRaw(requestParameters: ApiUserAuthChangePasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['changePasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'changePasswordRequest',
                'Required parameter "changePasswordRequest" was null or undefined when calling apiUserAuthChangePasswordPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/auth/change-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters['changePasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Change password
     */
    async apiUserAuthChangePasswordPost(requestParameters: ApiUserAuthChangePasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiUserAuthChangePasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Forgot password
     */
    async apiUserAuthForgotPasswordPostRaw(requestParameters: ApiUserAuthForgotPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfEmailNotificationResponse>> {
        if (requestParameters['forgotPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'forgotPasswordRequest',
                'Required parameter "forgotPasswordRequest" was null or undefined when calling apiUserAuthForgotPasswordPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/auth/forgot-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForgotPasswordRequestToJSON(requestParameters['forgotPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfEmailNotificationResponseFromJSON(jsonValue));
    }

    /**
     * Forgot password
     */
    async apiUserAuthForgotPasswordPost(requestParameters: ApiUserAuthForgotPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfEmailNotificationResponse> {
        const response = await this.apiUserAuthForgotPasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refresh token
     */
    async apiUserAuthRefreshTokenPostRaw(requestParameters: ApiUserAuthRefreshTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfRefreshTokenResponse>> {
        if (requestParameters['refreshTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'refreshTokenRequest',
                'Required parameter "refreshTokenRequest" was null or undefined when calling apiUserAuthRefreshTokenPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/auth/refresh-token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshTokenRequestToJSON(requestParameters['refreshTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfRefreshTokenResponseFromJSON(jsonValue));
    }

    /**
     * Refresh token
     */
    async apiUserAuthRefreshTokenPost(requestParameters: ApiUserAuthRefreshTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfRefreshTokenResponse> {
        const response = await this.apiUserAuthRefreshTokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset password
     */
    async apiUserAuthResetPasswordPostRaw(requestParameters: ApiUserAuthResetPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['resetPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'resetPasswordRequest',
                'Required parameter "resetPasswordRequest" was null or undefined when calling apiUserAuthResetPasswordPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/auth/reset-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters['resetPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Reset password
     */
    async apiUserAuthResetPasswordPost(requestParameters: ApiUserAuthResetPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiUserAuthResetPasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke token
     */
    async apiUserAuthRevokeTokenPostRaw(requestParameters: ApiUserAuthRevokeTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/auth/revoke-token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Revoke token
     */
    async apiUserAuthRevokeTokenPost(requestParameters: ApiUserAuthRevokeTokenPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiUserAuthRevokeTokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new admin user. Only accessible by existing admins through admin portal.
     * Create admin
     */
    async apiUserCreateAdminPostRaw(requestParameters: ApiUserCreateAdminPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateUserResponse>> {
        if (requestParameters['createUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserRequest',
                'Required parameter "createUserRequest" was null or undefined when calling apiUserCreateAdminPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/create-admin`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateUserResponseFromJSON(jsonValue));
    }

    /**
     * Create a new admin user. Only accessible by existing admins through admin portal.
     * Create admin
     */
    async apiUserCreateAdminPost(requestParameters: ApiUserCreateAdminPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateUserResponse> {
        const response = await this.apiUserCreateAdminPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new member user. Only accessible by admins through admin portal.
     * Create member
     */
    async apiUserCreateMemberPostRaw(requestParameters: ApiUserCreateMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateUserResponse>> {
        if (requestParameters['createUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserRequest',
                'Required parameter "createUserRequest" was null or undefined when calling apiUserCreateMemberPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/create-member`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateUserResponseFromJSON(jsonValue));
    }

    /**
     * Create a new member user. Only accessible by admins through admin portal.
     * Create member
     */
    async apiUserCreateMemberPost(requestParameters: ApiUserCreateMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateUserResponse> {
        const response = await this.apiUserCreateMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new staff user. Only accessible by admins through admin portal.
     * Create staff
     */
    async apiUserCreateStaffPostRaw(requestParameters: ApiUserCreateStaffPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateUserResponse>> {
        if (requestParameters['createUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserRequest',
                'Required parameter "createUserRequest" was null or undefined when calling apiUserCreateStaffPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/create-staff`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateUserResponseFromJSON(jsonValue));
    }

    /**
     * Create a new staff user. Only accessible by admins through admin portal.
     * Create staff
     */
    async apiUserCreateStaffPost(requestParameters: ApiUserCreateStaffPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateUserResponse> {
        const response = await this.apiUserCreateStaffPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates one person as Teacher, Staff, or both. An existing email keeps its password and does not get another welcome email. Roles that are already on the account are left in place.
     * Create an employee
     */
    async apiUserEmployeePostRaw(requestParameters: ApiUserEmployeePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSetEmployeeRolesResponse>> {
        if (requestParameters['createEmployeeRequest'] == null) {
            throw new runtime.RequiredError(
                'createEmployeeRequest',
                'Required parameter "createEmployeeRequest" was null or undefined when calling apiUserEmployeePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/employee`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmployeeRequestToJSON(requestParameters['createEmployeeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSetEmployeeRolesResponseFromJSON(jsonValue));
    }

    /**
     * Creates one person as Teacher, Staff, or both. An existing email keeps its password and does not get another welcome email. Roles that are already on the account are left in place.
     * Create an employee
     */
    async apiUserEmployeePost(requestParameters: ApiUserEmployeePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSetEmployeeRolesResponse> {
        const response = await this.apiUserEmployeePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate a parent account without deleting its records.
     * Deactivate parent
     */
    async apiUserIdDeactivatePutRaw(requestParameters: ApiUserIdDeactivatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserIdDeactivatePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/{id}/deactivate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivate a parent account without deleting its records.
     * Deactivate parent
     */
    async apiUserIdDeactivatePut(requestParameters: ApiUserIdDeactivatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserIdDeactivatePutRaw(requestParameters, initOverrides);
    }

    /**
     * Delete user
     */
    async apiUserIdDeleteRaw(requestParameters: ApiUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user
     */
    async apiUserIdDelete(requestParameters: ApiUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Login
     */
    async apiUserLoginPostRaw(requestParameters: ApiUserLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        if (requestParameters['loginRequest'] == null) {
            throw new runtime.RequiredError(
                'loginRequest',
                'Required parameter "loginRequest" was null or undefined when calling apiUserLoginPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/login`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters['loginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Login
     */
    async apiUserLoginPost(requestParameters: ApiUserLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.apiUserLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user
     */
    async apiUserPutRaw(requestParameters: ApiUserPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateUserRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserRequest',
                'Required parameter "updateUserRequest" was null or undefined when calling apiUserPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user
     */
    async apiUserPut(requestParameters: ApiUserPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserPutRaw(requestParameters, initOverrides);
    }

    /**
     * Register a new member user. Accessible by anyone through parent portal.
     * Register member
     */
    async apiUserRegisterMemberPostRaw(requestParameters: ApiUserRegisterMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateUserResponse>> {
        if (requestParameters['createUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserRequest',
                'Required parameter "createUserRequest" was null or undefined when calling apiUserRegisterMemberPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/register-member`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateUserResponseFromJSON(jsonValue));
    }

    /**
     * Register a new member user. Accessible by anyone through parent portal.
     * Register member
     */
    async apiUserRegisterMemberPost(requestParameters: ApiUserRegisterMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateUserResponse> {
        const response = await this.apiUserRegisterMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test if the user is authorized to access this endpoint. Should return 200 OK if authorized, otherwise 401 Unauthorized.
     * Test authorization
     */
    async apiUserTestAuthorizationGetRaw(requestParameters: ApiUserTestAuthorizationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/test-authorization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Test if the user is authorized to access this endpoint. Should return 200 OK if authorized, otherwise 401 Unauthorized.
     * Test authorization
     */
    async apiUserTestAuthorizationGet(requestParameters: ApiUserTestAuthorizationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserTestAuthorizationGetRaw(requestParameters, initOverrides);
    }

    /**
     * Sets the employee role to Teacher, Staff, or both. Does not change Admin or Member. Refuses to remove Teacher while the person still has classes or appointments.
     * Set an employee\'s role
     */
    async apiUserUserIdEmployeeRolePutRaw(requestParameters: ApiUserUserIdEmployeeRolePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSetEmployeeRolesResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUserUserIdEmployeeRolePut().'
            );
        }

        if (requestParameters['setEmployeeRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'setEmployeeRoleRequest',
                'Required parameter "setEmployeeRoleRequest" was null or undefined when calling apiUserUserIdEmployeeRolePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/{userId}/employee-role`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetEmployeeRoleRequestToJSON(requestParameters['setEmployeeRoleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSetEmployeeRolesResponseFromJSON(jsonValue));
    }

    /**
     * Sets the employee role to Teacher, Staff, or both. Does not change Admin or Member. Refuses to remove Teacher while the person still has classes or appointments.
     * Set an employee\'s role
     */
    async apiUserUserIdEmployeeRolePut(requestParameters: ApiUserUserIdEmployeeRolePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSetEmployeeRolesResponse> {
        const response = await this.apiUserUserIdEmployeeRolePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user by email
     */
    async apiUsersFindByEmailPostRaw(requestParameters: ApiUsersFindByEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserBaseResponse>> {
        if (requestParameters['getUserByEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'getUserByEmailRequest',
                'Required parameter "getUserByEmailRequest" was null or undefined when calling apiUsersFindByEmailPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/find-by-email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUserByEmailRequestToJSON(requestParameters['getUserByEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserBaseResponseFromJSON(jsonValue));
    }

    /**
     * Get user by email
     */
    async apiUsersFindByEmailPost(requestParameters: ApiUsersFindByEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserBaseResponse> {
        const response = await this.apiUsersFindByEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user
     */
    async apiUsersIdGetRaw(requestParameters: ApiUsersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUsersIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
    }

    /**
     * Get user
     */
    async apiUsersIdGet(requestParameters: ApiUsersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse> {
        const response = await this.apiUsersIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Google login
     */
    async googleLoginRaw(requestParameters: GoogleLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['googleLoginRequest'] == null) {
            throw new runtime.RequiredError(
                'googleLoginRequest',
                'Required parameter "googleLoginRequest" was null or undefined when calling googleLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/user/login/google`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleLoginRequestToJSON(requestParameters['googleLoginRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Google login
     */
    async googleLogin(requestParameters: GoogleLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.googleLoginRaw(requestParameters, initOverrides);
    }

    /**
     * Google login (callback)
     */
    async googleLoginCallbackRaw(requestParameters: GoogleLoginCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['tid'] != null) {
            queryParameters['tid'] = requestParameters['tid'];
        }

        if (requestParameters['rid'] != null) {
            queryParameters['rid'] = requestParameters['rid'];
        }

        if (requestParameters['returnUrl'] != null) {
            queryParameters['returnUrl'] = requestParameters['returnUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/user/login/google/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Google login (callback)
     */
    async googleLoginCallback(requestParameters: GoogleLoginCallbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.googleLoginCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Get users by Role. Role name should be provided as query parameter, e.g. /users/by-role?role=Admin
     * Get users by role
     */
    async usersByRoleGetRaw(requestParameters: UsersByRoleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUserBaseResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/by-role`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUserBaseResponseFromJSON));
    }

    /**
     * Get users by Role. Role name should be provided as query parameter, e.g. /users/by-role?role=Admin
     * Get users by role
     */
    async usersByRoleGet(requestParameters: UsersByRoleGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUserBaseResponse>> {
        const response = await this.usersByRoleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all users with pagination and optional search query.
     * Get all users
     */
    async usersScrollPostRaw(requestParameters: UsersScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetUserResponse>> {
        if (requestParameters['scrollUserRequest'] == null) {
            throw new runtime.RequiredError(
                'scrollUserRequest',
                'Required parameter "scrollUserRequest" was null or undefined when calling usersScrollPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScrollUserRequestToJSON(requestParameters['scrollUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetUserResponseFromJSON(jsonValue));
    }

    /**
     * Get all users with pagination and optional search query.
     * Get all users
     */
    async usersScrollPost(requestParameters: UsersScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetUserResponse> {
        const response = await this.usersScrollPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
